import chargeConnectorApi from 'api/chargeConnectorApi';
import AppConstants from 'general/constants/AppConstants';

const ChargeConnectorHelper = {
  callApiGetChargeConnectorDetail: async (id) => {
    const res = await chargeConnectorApi.getChargeConnectorDetail(id);
    const { result, connector, pricing } = res;
    if (result === 'success') {
      return { connector, pricing };
    }
    return {};
  },

  // lay mau trang thai voi sac
  getChargeConnectorStatusColor: (status) => {
    switch (status) {
      case AppConstants.chargeConnectorStatus.available:
        return 'success';
      case AppConstants.chargeConnectorStatus.charging:
        return 'primary';
      case AppConstants.chargeConnectorStatus.finishing:
        return 'warning';
      case AppConstants.chargeConnectorStatus.preparing:
        return 'primary';
      case AppConstants.chargeConnectorStatus.suspended:
        return 'danger';
      case AppConstants.chargeConnectorStatus.faulted:
        return 'danger';
      case AppConstants.chargeConnectorStatus.unavailable:
        return 'danger';
      default:
        return 'primary';
    }
  },
};

export default ChargeConnectorHelper;
